import {NewsPostData} from "../Data Types/NewsPostData";
import { combineReducers } from 'redux';
import { SET_NEWS_POSTS, SET_SELECTED_POST, SET_SELECTED_POST_ID, SET_NEWS_LOADING, SET_NEWS_ERROR, CLEAR_NEWS_ERROR } from "./actions";

// May be a good idea to fetch all of the news straight up.
// Perhaps fetch by groups of 10, great when there's shitloads of news. Consider Nitrome.
// Perhaps do as originally suggested by ChatGPT, fetch all headers, and have only one selectedPost fetched when requested.
export interface NewsStateType {
    // newsPostHeaders: NewsPostHeaderData[];
    newsPostDatas: NewsPostData[];  // TODO OPTIONAL: Transform into a dictionary (Record<string, NewsPostData>). Easier queries.
    selectedPostId: string | null;
    selectedPost: NewsPostData | null;  // Redundant because of the above 2 state variables?
    loading: boolean;
    error: string | null;
}

const initialNewsState: NewsStateType = {
    // newsPostHeaders: [],
    newsPostDatas: [],
    selectedPostId: null,
    selectedPost: null,
    loading: false,
    error: null,
};

// const SET_NEWS_POSTS = 'SET_NEWS_POSTS';
// const SET_SELECTED_POST_ID = 'SET_SELECTED_POST_ID';
// const SET_SELECTED_POST = 'SET_SELECTED_POST';

type Action =
    | { type: 'SET_NEWS_POSTS'; payload: NewsPostData[] }
    | { type: 'SET_SELECTED_POST_ID'; payload: string | null }
    | { type: 'SET_SELECTED_POST'; payload: NewsPostData | null }
    | { type: 'SET_NEWS_LOADING'; payload: boolean }
    | { type: 'SET_NEWS_ERROR'; payload: string }
    | { type: 'CLEAR_NEWS_ERROR' };

const newsReducer = (state = initialNewsState, action: Action): NewsStateType => {
    switch (action.type) {
        case SET_NEWS_POSTS:
            return { ...state, newsPostDatas: action.payload, loading: false, error: null };
        case SET_SELECTED_POST_ID:
            return { ...state, selectedPostId: action.payload };
        case SET_SELECTED_POST:
            return { ...state, selectedPost: action.payload };
        case SET_NEWS_LOADING:
            return { ...state, loading: action.payload };
        case SET_NEWS_ERROR:
            return { ...state, error: action.payload, loading: false };
        case CLEAR_NEWS_ERROR:
            return { ...state, error: null };
        default:
            return state;
    }
};

const rootReducer = combineReducers({news: newsReducer});
//export default rootReducer;  // TODO: Use this
export default newsReducer;

export type RootState = NewsStateType;
//export type RootState = ReturnType<typeof newsReducer>;  // I used to comment this out. Why?
